import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { createReducer } from '@lib/plugin-redux-core';
import { formPreviewHandlers } from './form-preview/form-preview.handler';
var initialState = {
  formPreviewApp: null
};
export var RESET_FORM_PREVIEW_APP_STATE = '@@form-nextjs-app/RESET_FORM_PREVIEW_APP_STATE';
export var resetFormPreviewAppState = function resetFormPreviewAppState() {
  return {
    type: RESET_FORM_PREVIEW_APP_STATE
  };
};
var formPreviewAppBaseReducer = createReducer(initialState, _toConsumableArray(formPreviewHandlers));
export var formNextjsAppReducer = function formNextjsAppReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type === RESET_FORM_PREVIEW_APP_STATE) {
    return initialState;
  }

  return formPreviewAppBaseReducer(state, action);
};